import {
  CalendarHeart,
  CalendarCheck,
  CalendarPlus,
  MessageCircleMore,
  PhoneCall,
  Footprints,
  PenTool,
} from 'lucide-react';
import type { ActivityType } from '~/types/customer-detail.types';

interface ActivityIconProps {
  type: ActivityType;
  isMyActivity: boolean;
}

const ICON_CLASS = 'translate-y-xs size-[2.7rem] flex-none';

function getIconColor(isMyActivity: boolean, isReservationType: boolean): string {
  if (isMyActivity) return 'text-brand';
  if (isReservationType) return 'text-success';
  return 'text-stone-800';
}

export function getActivityTextColor(type: ActivityType, isMyActivity: boolean): string {
  const isReservationType = ['同伴', '確約', '予約'].includes(type);
  if (isMyActivity) return 'text-brand';
  if (isReservationType) return 'text-success';
  return 'text-stone-800';
}

const ICON_MAP: Record<ActivityType, React.ComponentType<{ strokeWidth: number; className: string }>> = {
  'メッセ': MessageCircleMore,
  '訪問': Footprints,
  '電話': PhoneCall,
  '同伴': CalendarHeart,
  '確約': CalendarCheck,
  '予約': CalendarPlus,
  'DM': PenTool,
};

export function ActivityIcon({ type, isMyActivity }: ActivityIconProps) {
  const isReservationType = ['同伴', '確約', '予約'].includes(type);
  const iconColor = getIconColor(isMyActivity, isReservationType);
  const Icon = ICON_MAP[type];
  if (!Icon) return null;
  return <Icon strokeWidth={1.5} className={`${ICON_CLASS} ${iconColor}`} />;
}
